// extracted by mini-css-extract-plugin
export default {"container":"_1LdeS___RawToggle-module__container","input":"_2qUwR___RawToggle-module__input","label":"_2CGke___RawToggle-module__label","large":"eW7jT___RawToggle-module__large"};